/**
 * The i18n module name to associate errors with.
 */
export const MODULE_NAME = 'i18n';
